import styled from "styled-components";

export default styled.section`
    display: flex;
    flex-direction: column;
    gap: 32px;

    header {
        span {
            color: #001;
            font-size: 2.4rem;

            &:first-of-type:not(:last-of-type) {
                opacity: .2;

                &::after {
                    content: " ";
                }
            }
        }
    }
`;
